import { Component, Input, forwardRef, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommentsService } from '../../../../../../_core/domain/services/comments/comments.services';
import { SignatureComment } from '../../../../../../_core/domain/models/signature/signature-comment.model';
import { BaseComponent } from '../../../../../../components/common/baseComponent/base.component';

@Component({
  selector: 'signature-tool-dropdown',
  templateUrl: './signature-tool-dropdown.component.html',
  styleUrls: ['./signature-tool-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignatureToolDropdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignatureToolDropdownComponent extends BaseComponent implements ControlValueAccessor, OnInit {
  @Input() placeholder = '';
  @Input() resetValue = '';

  options: SignatureComment[] = [];
  value: any;
  isDisabled = false;

  constructor(private commentsService: CommentsService) {
    super();
  }

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  ngOnInit(): void {
    this._loadComments();
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value: any): void {
    this.value = value || '';
  }

  onValueChange(event: any): void {
    this.value = event;
    this.onChange(this.value);
    this.onTouched();
  }

  private _loadComments(): void {
    this.subscribe(this.commentsService.getComments(),
      (comments: SignatureComment[]) => {
        this.options = comments;
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}